import React from 'react';

import styles from './Settings.module.scss';
import {ContentBox} from '../..';

export interface Props {
  devFlags: string[];
  setDevFlags: any;
}

export default function Settings({devFlags, setDevFlags}: Props) {
  const handleCheck = (flag: string) => {
    const index = devFlags.indexOf(flag);
    if (index !== -1) {
      setDevFlags([...devFlags.slice(0, index), ...devFlags.slice(index + 1)]);
    } else {
      setDevFlags((oldDevFlags: string[]) => [...oldDevFlags, flag]);
    }
  };

  return (
    <div className={styles.Settings}>
      <ContentBox primary>
        <h3 style={{margin: 0}}>Dev Flags</h3>
        <br />
        <input
          type="checkbox"
          name="vehicle1"
          value="Bike"
          checked={devFlags.includes('cssBoxes')}
          onClick={() => {
            handleCheck('cssBoxes');
          }}
        />
        Enable CSS debugging boxes
        <br />
      </ContentBox>
    </div>
  );
}
